import React from "react";
import styles from "./OnlineTooltip.module.css";

interface OnlineTooltipProps {
  isOnline: boolean;
  since: Date | null;
}

export const OnlineTooltip: React.FC<OnlineTooltipProps> = ({ isOnline, since }) => {
  return (
    <div className={styles.tooltipBox}>
      {isOnline ? (
        <>
          <div className={styles.statusRow}><span className={styles.dotOnline} /> <b>Online</b></div>
          <div className={styles.label}>Online since:</div>
          <div className={styles.value}>{since ? since.toLocaleString() : "Unknown"}</div>
        </>
      ) : (
        <>
          <div className={styles.statusRow}><span className={styles.dotOffline} /> <b>Offline</b></div>
          <div className={styles.label}>Last login:</div>
          <div className={styles.value}>{since ? since.toLocaleString() : "Unknown"}</div>
        </>
      )}
    </div>
  );
};
